import { combineReducers } from 'redux';
import userInfo from './userInfoReducer';
import pageInfo from './pageInfoReducer';

export default combineReducers({
    userInfo,
    pageInfo
})
